export default __webpack_public_path__ + "static/media/NICIA_Sesion_canacem.8b2cd509.jpg";